import { createApp } from 'vue'
import App from './App.vue'
import ViewUIPlus from 'view-ui-plus'
import './styles/index.less'
import router from './router'

ViewUIPlus.Message.config({ top: 120 })
ViewUIPlus.Notice.config({ top: 120 })

createApp(App).use(ViewUIPlus).use(router).mount('#app')
